import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

import { Button } from "@alpacahq/ui/old";

export interface CryptoAgreementAccountSetupModalProps {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  isSettingUpAccount: boolean;
  onSignAgreement: () => void;
  agreementUrl: string;
}

export const CryptoAgreementAccountSetupModal = ({
  isOpen,
  onClose,
  isLoading,
  isSettingUpAccount,
  onSignAgreement,
  agreementUrl,
}: CryptoAgreementAccountSetupModalProps) => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    className="relative z-50 min-h-[800px] overflow-y-auto"
  >
    <DialogBackdrop
      transition
      className="fixed inset-0 bg-black/30 duration-300 ease-out data-closed:opacity-0"
    />
    <div className="fixed inset-0 w-screen overflow-y-auto p-4">
      <div className="flex min-h-full items-center justify-center">
        <DialogPanel
          transition
          className="w-full max-w-[800px] rounded border border-gray-200 bg-white px-0 py-2 duration-300 ease-out data-closed:scale-95 data-closed:opacity-0"
        >
          <DialogTitle className="px-4 font-semibold text-gray-800 text-lg">
            {isSettingUpAccount
              ? "We're setting up your crypto account"
              : "Alpaca Crypto Customer Agreement"}
          </DialogTitle>
          {isSettingUpAccount ? (
            <div className="border-gray-300 border-y px-4 pt-4">
              <p>
                Our systems are processing your request and creating your crypto
                account. This new account enables trading crypto and access to
                crypto wallets. Please wait several minutes and refresh your
                browser tab to make your first crypto trade or deposit.
              </p>
            </div>
          ) : (
            <iframe
              id="crypto-agreement-iframe"
              title="Alpaca Crypto Customer Agreement"
              height="500px"
              width="100%"
              src={agreementUrl}
              className="h-[500px] max-h-96 overflow-y-auto border-gray-300 border-y px-4 pt-4"
              style={{ scrollBehavior: "smooth" }}
            />
          )}
          <div className="mt-2 px-4">
            {isSettingUpAccount ? (
              <Button className="ml-auto" variant="v2/stroke" onClick={onClose}>
                Close
              </Button>
            ) : (
              <div className="flex justify-end gap-4">
                <Button variant="v2/stroke" onClick={onClose}>
                  Cancel
                </Button>
                <Button
                  variant="v2/filled"
                  onClick={onSignAgreement}
                  loading={isLoading}
                >
                  I Agree
                </Button>
              </div>
            )}
          </div>
        </DialogPanel>
      </div>
    </div>
  </Dialog>
);
